define(["require", "exports", "./BenjaminMoore_DesignerClassics_en-us"], function (require, exports, BenjaminMoore_DesignerClassics_en_us_1) {
    "use strict";
    exports.__esModule = true;
    function renderColors(sb, colors) {
        sb.push('<div class="color-picker">');
        colors.forEach(function (x) { return sb.push("<div style=\"background-color:" + x.rgb + "\" data-rgb=\"" + x.rgb + "\" title=\"" + x.name + "\"></div>"); });
        sb.push('</div>');
    }
    function renderColorSection(sb, title, colors, val) {
        sb.push('<div class="color-section">');
        sb.push("<input type=\"hidden\" name=\"wallColor\"  id=\"wallColor\" value=\"" + val + "\"/>");
        renderColors(sb, colors);
        sb.push('</div');
    }
    function renderAllColors($container, curColor) {
        var sb = [];
        renderColorSection(sb, 'Designer classics', BenjaminMoore_DesignerClassics_en_us_1["default"], curColor);
        $container.append(sb.join(''));
        return $container;
    }
    exports.renderAllColors = renderAllColors;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/paintColors.js
// module id = 62
// module chunks = 0